import React from 'react'
import { Helmet } from 'react-helmet';
import ContactForm from '../components/ContactForm';

const Contact = () => {
  return (
    <div>
    <Helmet>
      <title>Contact Us</title>
    </Helmet>
    <div className='main-container'>
      
      <div className="section">
      <div className="page-heading">
        <h1>Contact Us</h1>
      </div>
      <div className="grid-2">
        <div className="address-section">
          <h2>Get in touch</h2>
            <p>Indian Institute of Technology Gandhinagar, <br/>Palaj, Gandhinagar, Gujarat, PIN-382355 <br/>
              email: sports@iitgn.ac.in
            </p>




        </div>
        <div className="contact-form-section">
        <ContactForm/>
        </div>
      </div>
      </div>


            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3541.961593577007!2d72.68645039925686!3d23.211474296257556!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c2ba9499d441d%3A0xf757fc72be31623c!2sIIT%20Gandhinagar%20Sports%20Complex!5e0!3m2!1sen!2sin!4v1677868562754!5m2!1sen!2sin" width="100%" height="400" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex={0}
              referrerPolicy="no-referrer-when-downgrade" title='Google Map'></iframe>

      

      
      

    </div>

  </div>
  )
}

export default Contact